// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__QSCDW","buttons":"Footer_buttons__2vRy9"};